import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { SectionTitle, Card } from "../ui";

export default function DisclaimersManager() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/disclaimers").then((res) => setItems(res.data));
  useEffect(() => { load(); }, []);

  const save = async (d) => {
    await api.put(`/admin/disclaimers/${d.key}`, { text: d.text });
    toast.success("Disclaimer saved");
  };

  const setText = (key, text) => setItems((arr) => arr.map((d) => (d.key === key ? { ...d, text } : d)));

  return (
    <div data-testid="admin-disclaimers">
      <SectionTitle title="Disclaimers" subtitle="Update 'rules can change' notices shown across the site." />
      <div className="space-y-4">
        {items.map((d) => (
          <Card key={d.key}>
            <p className="text-xs uppercase tracking-wide text-sage-700 mb-2">{d.key}</p>
            <textarea
              data-testid={`disclaimer-${d.key}`}
              rows={3}
              value={d.text}
              onChange={(e) => setText(d.key, e.target.value)}
              className="w-full bg-white border border-sand-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sage/50"
            />
            <button data-testid={`disclaimer-save-${d.key}`} onClick={() => save(d)} className="mt-3 rounded-full bg-terracotta px-5 py-2 text-sm text-white font-medium hover:bg-terracotta-hover">
              Save
            </button>
          </Card>
        ))}
      </div>
    </div>
  );
}
